import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import BackOrderedItemsState from "@galarson/Store/BackOrderedItems/BackOrderedItemsState";
import { UpdateSearchFieldsType } from "@insite/client-framework/Types/UpdateSearchFieldsType";
import { Draft } from "immer";
import { GetOrdersApiParameter } from "@galarson/Handlers/BackOrderedItemsOrderService";
const initialState: BackOrderedItemsState = {
    getOrdersParameter: {
        sort: "OrderHistory.OrderDate DESC,OrderHistory.ErpOrderNumber DESC,ProductErpNumber DESC",
        fromDate: "",
        itemnumber: "",
        ordernumber: "",
        ponumber: "",
        toDate: ""
    },
    filtersOpen: false,
    isLoading: false,
    backOrderedItems:[]
};

const reducer = {
    "Data/BackOrdered/BeginLoadOrders": (
        draft: Draft<BackOrderedItemsState>,
        action: { parameter: GetOrdersApiParameter },
    ) => {
        draft.getOrdersParameter = action.parameter;
        draft.isLoading = true;
    },
    "Data/BackOrdered/CompleteLoadOrders": (draft: Draft<BackOrderedItemsState>,  action: {
        collection: any; parameter: GetOrdersApiParameter & UpdateSearchFieldsType 
},) => {
        draft.isLoading = false;
        draft.backOrderedItems = action?.collection?.backorderedItems;
    },
    "Data/BackOrdered/updateApiParameter": (draft: Draft<BackOrderedItemsState>,  action: { parameter: GetOrdersApiParameter }) => {
        draft.getOrdersParameter =  action.parameter;
    },
    "Data/BackOrdered/ClearSearchData": (draft: Draft<BackOrderedItemsState>) => {
        draft.getOrdersParameter =  {
            sort: "OrderHistory.OrderDate DESC,OrderHistory.ErpOrderNumber DESC,ProductErpNumber DESC",
            fromDate: "",
            itemnumber: "",
            ordernumber: "",
            ponumber: "",
            toDate: ""
        }
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
